<div class="flex min-h-screen bg-[#05070F] text-white">
  @if (sidebarOpen()) {
    <div class="fixed inset-0 z-30 bg-black/60 lg:hidden" (click)="sidebarOpen.set(false)"></div>
  }

  <!-- 侧边栏：lg 常驻；窄屏抽屉 -->
  <aside
    class="fixed inset-y-0 left-0 z-40 w-64 shrink-0 flex flex-col overflow-hidden bg-gradient-to-br from-[#0B1026] to-[#05070F]
           shadow-[8px_0_30px_rgba(51,230,255,0.12)] transform transition-transform duration-200
           lg:sticky lg:top-0 lg:h-screen lg:translate-x-0"
    [class]="sidebarOpen() ? 'translate-x-0' : '-translate-x-full'">
    <div class="h-16 lg:h-20 shrink-0 flex items-center justify-center gap-3 border-b border-[#33E6FF]/20">
      <svg class="w-8 h-8 text-[#33E6FF]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9v3" />
      </svg>
      <span class="font-bold tracking-wide"><span class="text-[#33E6FF]">EP</span><span class="text-white">inno</span></span>
    </div>

    <nav class="mt-5 flex-1 overflow-y-auto min-h-0">
      @for (n of nav; track n.key) {
        @if (n.header) {
          <div class="px-6 pt-5 pb-1 text-[11px] uppercase tracking-wide text-white/40">{{ n.key | translate }}</div>
        } @else if (n.route) {
          <a [routerLink]="n.route" routerLinkActive #rla="routerLinkActive" (click)="sidebarOpen.set(false)"
             class="flex items-center gap-4 px-6 py-4 cursor-pointer hover:bg-[#33E6FF]/[0.08] transition"
             [class]="rla.isActive ? 'border-l-4 border-[#33E6FF] bg-gradient-to-r from-[#33E6FF]/10 to-[#FF3CAC]/5' : ''">
            <svg class="w-5 h-5" [class]="rla.isActive ? 'text-[#33E6FF]' : 'text-white/70'" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
              @for (p of (n.icon ?? []); track p) { <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="p" /> }
            </svg>
            <span [class]="rla.isActive ? 'text-white font-semibold' : 'text-white/70'">{{ n.key | translate }}</span>
          </a>
        } @else {
          <span class="flex items-center gap-4 px-6 py-4 text-white/40 cursor-default">
            <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
              @for (p of (n.icon ?? []); track p) { <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="p" /> }
            </svg>
            <span>{{ n.key | translate }}</span>
          </span>
        }
      }
    </nav>

    <div class="p-4 shrink-0">
      <div class="flex items-center justify-center gap-2">
        <!-- Activity Log：琥珀色（与企业档案区分） -->
        <a routerLink="/logs" routerLinkActive #rlaLog="routerLinkActive" (click)="sidebarOpen.set(false)"
           class="w-10 h-10 grid place-items-center rounded-lg hover:bg-amber-400/10 transition"
           [class]="rlaLog.isActive ? 'text-amber-300 bg-amber-400/15' : 'text-amber-400/75'"
           [title]="'nav.logs' | translate" [attr.aria-label]="'nav.logs' | translate">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
          </svg>
        </a>
        <!-- 企业档案：青色（与日志区分） -->
        <a routerLink="/profile" routerLinkActive #rlaProfile="routerLinkActive" (click)="sidebarOpen.set(false)"
           class="w-10 h-10 grid place-items-center rounded-lg hover:bg-[#33E6FF]/[0.10] transition"
           [class]="rlaProfile.isActive ? 'text-[#33E6FF] bg-[#33E6FF]/15' : 'text-[#33E6FF]/75'"
           [title]="'nav.profile' | translate" [attr.aria-label]="'nav.profile' | translate">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21a.75.75 0 01.75.75V21" />
          </svg>
        </a>
        <!-- 多语言切换：安全与退出之间，国旗标识，向上弹出 -->
        <div class="relative">
          <button (click)="langOpen.set(!langOpen())"
                  class="w-10 h-10 grid place-items-center rounded-lg hover:bg-[#33E6FF]/[0.10] transition text-lg leading-none"
                  [title]="currentLangLabel()" [attr.aria-label]="'common.language' | translate">
            <span>{{ langFlag(currentLang()) }}</span>
          </button>
          @if (langOpen()) {
            <div class="fixed inset-0 z-40" (click)="langOpen.set(false)"></div>
            <div class="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 z-50 w-40 rounded-lg bg-[#0B1026] border border-[#33E6FF]/25 shadow-2xl py-1">
              @for (l of langs; track l.code) {
                <button (click)="switchLang(l.code)"
                        class="w-full text-left px-3 py-2 text-sm hover:bg-[#33E6FF]/10 transition flex items-center gap-2"
                        [class]="l.code === currentLang() ? 'text-[#33E6FF]' : 'text-white/80'">
                  <span class="text-base leading-none">{{ langFlag(l.code) }}</span>
                  <span class="flex-1">{{ l.label }}</span>
                  @if (l.code === currentLang()) { <span>✓</span> }
                </button>
              }
            </div>
          }
        </div>
        <!-- Logout：图标化 -->
        <button (click)="logout()"
                class="w-10 h-10 grid place-items-center rounded-lg text-red-400 hover:bg-red-500/10 transition"
                [title]="'common.logout' | translate" [attr.aria-label]="'common.logout' | translate">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
          </svg>
        </button>
      </div>
      <div class="text-white/40 text-xs mt-2 text-center">v0.0.1</div>
    </div>
  </aside>

  <!-- 主区 -->
  <div class="flex-1 flex flex-col min-w-0">
    <header class="h-16 lg:h-20 flex items-center px-4 sm:px-6 bg-white/[0.06] border-b border-[#33E6FF]/20 shadow-[0_4px_12px_rgba(51,230,255,0.12)]">
      <button class="lg:hidden mr-3 text-white/70 hover:text-white" (click)="sidebarOpen.set(true)" [attr.aria-label]="'common.menu' | translate">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
        </svg>
      </button>
      <span class="hidden sm:inline text-white/60">{{ 'common.home' | translate }}</span>
      <span class="hidden sm:inline mx-2 text-white/40">›</span>
      <span class="font-bold">{{ 'common.console' | translate }}</span>

      <div class="ml-auto flex items-center gap-3 sm:gap-5">
        <div class="hidden md:flex items-center gap-2 w-56 lg:w-72 h-10 px-3 rounded-lg bg-white/[0.08] border border-[#33E6FF]/20">
          <svg class="w-4 h-4 text-white/50" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
          <input [placeholder]="'common.search' | translate" class="bg-transparent text-sm text-white placeholder-white/40 focus:outline-none w-full" />
        </div>

        <!-- 企业切换器：搜索栏之后，始终醒目可见（渐变高亮 + 辉光；0/1 家也显示当前企业）。 -->
        <div class="relative">
          @let active = ent.active();
          <button (click)="entOpen.set(!entOpen())"
                  class="flex items-center gap-2 h-10 pl-2 pr-2.5 rounded-lg bg-gradient-to-r from-[#33E6FF]/15 to-[#FF3CAC]/10 border border-[#33E6FF]/40 hover:border-[#33E6FF]/70 shadow-[0_0_10px_rgba(51,230,255,0.18)] transition max-w-[11rem] sm:max-w-[16rem]"
                  [attr.aria-label]="'enterprise.switch' | translate">
            <span class="w-7 h-7 shrink-0 rounded-md bg-gradient-to-br from-[#33E6FF] to-[#FF3CAC] text-[#0B1026] grid place-items-center text-xs font-bold">
              {{ active ? (enterpriseLabel(active).charAt(0) || 'E') : 'E' }}
            </span>
            <span class="min-w-0 text-left leading-tight">
              <span class="block text-[10px] text-white/50">{{ 'enterprise.current' | translate }}</span>
              <span class="block truncate text-sm text-white font-semibold">{{ active ? enterpriseLabel(active) : ('enterprise.none' | translate) }}</span>
            </span>
            <svg class="w-4 h-4 shrink-0 text-white/60" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 15 3.75 3.75L15.75 15m-7.5-6L12 5.25 15.75 9" />
            </svg>
          </button>
          @if (entOpen()) {
            <div class="absolute right-0 mt-2 w-64 rounded-lg bg-[#0B1026] border border-[#33E6FF]/20 shadow-[0_8px_24px_rgba(0,0,0,0.5)] py-1 z-50 max-h-80 overflow-auto">
              <div class="px-4 py-2 text-[11px] uppercase tracking-wide text-white/40">{{ 'enterprise.myEnterprises' | translate }}</div>
              @if (!ent.enterprises().length) {
                <div class="px-4 py-3 text-sm text-white/40">{{ 'enterprise.empty' | translate }}</div>
              } @else {
                @for (e of ent.enterprises(); track e.applicationId) {
                  <div class="flex items-center hover:bg-[#33E6FF]/10 transition"
                       [class]="e.applicationId === ent.activeId() ? 'text-[#33E6FF]' : 'text-white/80'">
                    <button (click)="selectEnterprise(e.applicationId!)"
                            class="flex-1 min-w-0 text-left px-4 py-2.5 text-sm flex items-center gap-2.5">
                      <span class="w-6 h-6 shrink-0 rounded bg-white/10 grid place-items-center text-[11px] font-bold">{{ enterpriseLabel(e).charAt(0) || 'E' }}</span>
                      <span class="flex-1 min-w-0">
                        <span class="block truncate">{{ enterpriseLabel(e) }}</span>
                        <span class="block text-[10px] text-white/40">{{ ('appStatus.' + (e.applicationStatus || 'unknown')) | translate }}</span>
                      </span>
                      @if (e.applicationId === ent.activeId()) { <span class="shrink-0">✓</span> }
                    </button>
                    @if (isDraftStatus(e.applicationStatus)) {
                      <button (click)="createEnterprise(e.applicationId)" [disabled]="creatingEnterprise()"
                              class="shrink-0 px-3 py-2.5 text-xs text-[#FF3CAC] hover:text-white transition disabled:opacity-50">
                        {{ 'enterprise.resume' | translate }}
                      </button>
                    }
                  </div>
                }
              }
              <!-- 新建企业：常驻底部（无企业时即主入口）-->
              <div class="border-t border-white/10 mt-1 pt-1">
                <button (click)="createEnterprise()" [disabled]="creatingEnterprise()"
                        class="w-full text-left px-4 py-2.5 text-sm text-[#33E6FF] hover:bg-[#33E6FF]/10 transition flex items-center gap-2.5 disabled:opacity-50">
                  <span class="w-6 h-6 shrink-0 rounded bg-[#33E6FF]/15 grid place-items-center text-base leading-none">＋</span>
                  <span>{{ (creatingEnterprise() ? 'common.loading' : 'enterprise.create') | translate }}</span>
                </button>
              </div>
            </div>
          }
        </div>

        <button class="relative text-white/70 hover:text-white">
          <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
          </svg>
          <span class="absolute top-1 right-1 w-2 h-2 rounded-full bg-[#FF3CAC]"></span>
        </button>
        <div class="flex items-center gap-2">
          <div class="w-8 h-8 rounded-full bg-[#33E6FF] text-[#0B1026] grid place-items-center text-xs font-bold">AD</div>
          <div class="leading-tight hidden sm:block">
            <div class="text-sm font-bold">{{ user() ?? ('common.adminUser' | translate) }}</div>
            <div class="text-[10px] text-white/60">{{ 'common.superAdmin' | translate }}</div>
          </div>
        </div>
      </div>
    </header>

    <main class="flex-1 overflow-auto p-4 sm:p-6">
      <router-outlet />
    </main>
  </div>
</div>
